import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import type { IImagesPolylineInfo } from './interfaces';
import type * as THREE from 'three';

export class ImagesPolylineInfo implements IImagesPolylineInfo {
  @observable private _slicesCount = 0;

  @observable private _currentSlice = 0;

  @observable private _polylinePoints: Array<THREE.Vector3> = [];

  @observable private _polylineNormals: Array<THREE.Vector3> = [];

  public constructor() {
    makeObservable(this);
  }

  public setInfo(points: Array<THREE.Vector3>, normals: Array<THREE.Vector3>): boolean {
    const pointsAreEqual =
      this._polylinePoints.length === points.length && this._polylinePoints.every((v, i) => v.equals(points[i]));
    const normalsAreEqual =
      this._polylineNormals.length === normals.length && this._polylineNormals.every((v, i) => v.equals(normals[i]));
    if (!pointsAreEqual || !normalsAreEqual) {
      // TODO: [chebotarev] think on this before commit
      runInAction(() => {
        this._polylinePoints = points;
        this._polylineNormals = normals;
        this._slicesCount = points.length ? points.length - 1 : 0;
      });
    }
    return !pointsAreEqual;
  }

  @action
  public setCurrentSlice(sliceCount: number): void {
    this._currentSlice = sliceCount;
  }

  @computed
  public get slicesCount(): number {
    return this._slicesCount;
  }

  @computed
  public get currentSlice(): number {
    return this._currentSlice;
  }

  @computed
  public get polylinePoints(): Array<THREE.Vector3> {
    return this._polylinePoints;
  }

  @computed
  public get polylineNormals(): Array<THREE.Vector3> {
    return this._polylineNormals;
  }
}
